//ACTIONS
export const FETCH_REVIEWS = "FETCH_REVIEWS";

//SAGA
export const FETCH_REVIEW_DATA = 'FETCH_REVIEW_DATA';